export default __webpack_public_path__ + "static/media/Restriction_Enzyme_Haelli_RE.6aa36918.svg";